import React, { PureComponent } from "react";
import RestorePurchases from './RestorePurchases.js';
import Constants from '../Constants.js';
import './Menu.css';

// Font Awesome
import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faHeart } from '@fortawesome/free-solid-svg-icons'
library.add(faHeart);

class Footer extends PureComponent {
    render() {
        return (
            <div
                className="FooterWrapper"
            >
                <div
                    style={{
                        position: 'relative',
                        width: '100%',
                        maxWidth: '520px',
                        left: '50%',
                        padding: '30px 10px 20px 10px',
                        transform: 'translateX(-50%)',
                        boxSizing: 'border-box',
                    }}
                >
                    {
                        // Display an option to restore purchases if in the app version
                        (Constants.appVersion) &&
                        <RestorePurchases />
                    }
                    <p
                        className="Paragraph"
                        style={{
                            color: '#fff',
                        }}
                    >
                        Made with
                        <FontAwesomeIcon
                            icon="heart"
                            style={{
                                margin: '0 6px',
                            }}
                        />
                        by
                        {
                            !Constants.coolmathVersion &&
                            <a href="http://aidanbauer.me" target="_blank" rel="noopener noreferrer"> Aidan Bauer </a>
                        }
                        {
                            Constants.coolmathVersion && 
                            <span> Aidan Bauer </span>
                        }
                        <br />
                        in Boston, MA
                    </p>
                </div>
            </div>
        );
    }
}

export default Footer;
